const events = {
  callInfo_api_request: "callInfo_api_request",
  callInfo_api_response: "callInfo_api_response",
  subcription_redirect: "sub_redirect",
  unsubscription_api_request: "unsub_api_request",
  unsubscription_api_response: "unsub_api_response",
  checksub_api_request: "checksub_api_request",
  checksub_api_response: "checksub_api_response",
};
const screen = {
  home: "home_s",
  dailer: "dailer_s",
  recent: "recent_s",
  contact: "contact_s",
  account: "account_s",
};

export { events, screen };
